import { NavbarNode } from 'app/shared/model/navbar_node.model';

/**
 * Clase que envuelve NavbarNode para añadir funcionalidades del tree de circlon
 */
export class TreeWrapperNode {
  data: NavbarNode;
  parent: TreeWrapperNode | null = null;
  children: TreeWrapperNode[] = [];
  isExpanded: boolean = false;
  isActive: boolean = false;
  isFocused: boolean = false;
  isHidden: boolean = false;
  level: number = 0;
  index: number = 0;
  treeModel: any;

  constructor(data: NavbarNode, parent: TreeWrapperNode | null = null, treeModel: any = null) {
    this.data = data;
    this.parent = parent;
    this.treeModel = treeModel;
    
    // Convertir children de NavbarNode a TreeWrapperNode
    if (data.children && data.children.length > 0) {
      this.children = data.children.map((child, idx) => {
        const childNode = new TreeWrapperNode(child, this, treeModel);
        childNode.index = idx;
        childNode.level = this.level + 1;
        return childNode;
      });
    }
  }

  get id() {
    return this.data.id;
  }

  get hasChildren(): boolean {
    return this.children.length > 0;
  }

  get isLeaf(): boolean {
    return !this.hasChildren;
  }

  get isCollapsed(): boolean {
    return !this.isExpanded;
  }

  get isRoot(): boolean {
    return this.parent === null;
  }

  getClass(): string {
    let className = `tree-node-level-${this.level}`;
    if (this.data.product) {
      className += ` product-${this.data.product}`;
    }
    return className;
  }

  expand(): void {
    this.isExpanded = true;
    if (this.treeModel) {
      this.treeModel.setExpandedNode(this, true);
    }
  }

  collapse(): void {
    this.isExpanded = false;
    if (this.treeModel) {
      this.treeModel.setExpandedNode(this, false);
    }
  }

  collapseAll(): void {
    this.collapse();
    this.children.forEach(child => child.collapseAll());
  }

  expandAll(): void {
    this.expand();
    this.children.forEach(child => child.expandAll());
  }

  toggle(): void {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  mouseAction(actionName: string, $event: MouseEvent): void {
    if (this.treeModel && this.treeModel.options.actionMapping?.mouse?.[actionName]) {
      this.treeModel.options.actionMapping.mouse[actionName](this.treeModel, this, $event);
    }
  }

  allowDrag(): boolean {
    if (this.treeModel && this.treeModel.options.allowDrag) {
      return this.treeModel.options.allowDrag(this);
    }
    return false;
  }

  get allowDrop() {
    if (this.treeModel && this.treeModel.options.allowDrop) {
      return this.treeModel.options.allowDrop(this);
    }
    return false;
  }

  onDrop($event: any): void {
    // Implementación placeholder para drag & drop
  }

  hide(): void {
    this.isHidden = true;
  }

  show(): void {
    this.isHidden = false;
  }
}

